import { BirthDateFields } from "@/types/childForm";

export const calculateAge = (birthDate: BirthDateFields): number => {
  if (!birthDate.year || !birthDate.month || !birthDate.day) {
    return 0;
  }

  const today = new Date();
  const birthDateTime = new Date(
    Number(birthDate.year),
    Number(birthDate.month) - 1,
    Number(birthDate.day),
    12, // Set to noon to avoid timezone issues
    0,
    0,
    0
  );
  
  let age = today.getFullYear() - birthDateTime.getFullYear();
  const monthDiff = today.getMonth() - birthDateTime.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateTime.getDate())) {
    age--;
  }
  
  return age;
};

export const getInitialDate = (birthday?: string): BirthDateFields => {
  if (!birthday) {
    return {
      month: "",
      day: "",
      year: ""
    };
  }

  const [year, month, day] = birthday.split('-');
  
  return {
    month: month || "",
    day: day || "",
    year: year || ""
  };
};

export const formatBirthDate = (birthDate: BirthDateFields): string => {
  if (!birthDate.month || !birthDate.day || !birthDate.year) {
    return "";
  }

  const month = String(birthDate.month).padStart(2, '0');
  const day = String(birthDate.day).padStart(2, '0');
  const year = birthDate.year;

  return `${year}-${month}-${day}`;
};